var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-tooltip',{attrs:{"options":_vm.options}},[_c('div',{staticClass:"map-tooltip"},[_c('h4',{staticClass:"window__title"},[_vm._v(_vm._s(_vm.cutString(_vm.title, 70)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }